import React, { useState, useEffect } from "react";
import TextField from '@material-ui/core/TextField';
import { Autocomplete } from '@material-ui/lab';
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import { http } from "../../services/http";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(0.4),
  },
  listbox: {
    maxHeight: 300,
    overflow: 'auto',
  },
}));

const NomeD2iCirurgiaoFormatter = ({ value }) => {
  const classes = useStyles();
  return (<TextField className={classes.root} value={value || ""} InputProps={{ disableUnderline: true }} />)
};

const NomeD2iCirurgiaoEditor = ({ value, onValueChange }) => {
  const [options, setOptions] = useState([]);
  const classes = useStyles();
  const [inputValue, setInputValue] = useState(value || "");
  const [timer, setTimer] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (value && value !== inputValue) {
      setInputValue(value);
      setOpen(false);
    }
  }, [value]);

  function searchCirurgioes(searchText) {
    if (searchText.length < 1) {
      setOptions([]);
      setOpen(false);
      return;
    }

    http.get(`carga-hiae/surgeons/search-by-name?search=${searchText}`)
      .then((response) => {
        if (response?.status === 200) {
          const results = response?.data || [];
          setOptions(results);
          setOpen(results.length > 0);
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar cirurgiões por nome:", error);
        setOptions([]);
        setOpen(false);
      });
  }

  function handleInputChange(event, newInputValue) {
    setInputValue(newInputValue);
    onValueChange(newInputValue);

    clearTimeout(timer);
    setTimer(
      setTimeout(function () {
        searchCirurgioes(newInputValue);
      }, 300)
    );
  }

  function handleChange(event, newValue) {
    if (newValue && typeof newValue === 'object') {
      // Atualiza o nome D2i com o nome do cirurgião
      setInputValue(newValue.surname);
      onValueChange(newValue.surname);
      setOpen(false);
    }
  }

  return (
    <div className={classes.root}>
      <Autocomplete
        freeSolo
        open={open}
        onOpen={() => {
          if (options.length > 0) setOpen(true);
        }}
        onClose={() => setOpen(false)}
        options={options}
        inputValue={inputValue}
        size="small"
        ListboxProps={{
          className: classes.listbox,
          style: { maxHeight: 300 }
        }}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          }
          return option?.surname || "";
        }}
        onInputChange={handleInputChange}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} label="" variant="standard" />}
      />
    </div>
  );
};

export const NomeD2iCirurgiaoTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={NomeD2iCirurgiaoFormatter}
    editorComponent={NomeD2iCirurgiaoEditor}
    {...props}
  />
);
